export const CacheKeys = {
    ORDER: 'order',
    TRADE: 'trade'
}

export const filtersIntitialState = () => {
    const keys = Object.keys(CacheKeys)
    const initial = {}
    keys.forEach(key => {
        const value = CacheKeys[key]
        initial[value] = {}
    })
    return initial
}


export const paginationInitialState = () => {
    const keys = Object.keys(CacheKeys)
    const initial = {}
    keys.forEach(key => {
        const value = CacheKeys[key]
        initial[value] = {page: 1, limit: 10}
    })
    return initial
}

const tradeTypeOptions = ['limit', 'market', 'stop', 'oco']
const transactionTypeOptions = ['buy', 'sell']


export const orderFilterOptions = [
    { name: 'coin', search: 'coin' },
    { name: 'pair', search: 'pair' },
    { name: 'date', search: 'date' },
    { name: 'trade-type', search: 'submit', options: tradeTypeOptions },
    { name: 'transaction-type', search: 'type', options: transactionTypeOptions },
]

export const tradeFilterOptions = [
    { name: 'coin', search: 'order.coin' },
    { name: 'pair', search: 'order.pair' },
    { name: 'date', search: 'date' },
    { name: 'trade-type', search: 'order.submit', options: tradeTypeOptions },
    { name: 'transaction-type', search: 'order.type', options: transactionTypeOptions },
]

export const tradeSortOptions = [
    {title: 'amount', sort: 'amount'},
    {title: 'unitPrice', sort: 'priceUnit'},
    {title: 'price', sort: 'price'},
    {title: 'date', sort: 'createdAt'}
]

export const orderSortOptions = [
    {title: 'unitPrice', sort: 'priceUnit'},
    {title: 'price', sort: 'price'},
    {title: 'date', sort: 'createdAt'}
]
